import React from "react";
import { Link } from "react-router-dom";
import { Phone, CalendarCheck, CheckCircle2, MapPin } from "lucide-react";
import { Button } from "./ui/button";
import { COVERAGE_BULLETS, NAP } from "../lib/localContent";
import { trackPhoneClick } from "../lib/analytics";

const H = { fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800 };

export const LocalConversionFooter = ({ variant = "residential", testIdPrefix = "local", className = "" }) => {
  const headline = variant === "commercial"
    ? "Schedule Local Commercial Refrigeration Repair in Decatur & Metro Atlanta"
    : "Schedule Local Appliance Repair in Decatur & Metro Atlanta";
  return (
    <section className={`py-14 bg-white ${className}`} data-testid={`${testIdPrefix}-local-footer`}>
      <div className="max-w-5xl mx-auto px-6">
        <div className="rounded-2xl bg-slate-900 text-white p-7 lg:p-10">
          <div className="text-orange-400 text-xs font-bold uppercase tracking-[0.25em] mb-2">Georgia · Metro Atlanta Only</div>
          <h2 className="text-3xl lg:text-4xl font-extrabold tracking-tight" style={H} data-testid={`${testIdPrefix}-local-footer-headline`}>
            {headline}
          </h2>
          <p className="mt-2 text-lg text-slate-300">Fast diagnostic dispatch across DeKalb County.</p>

          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <a href={`tel:${NAP.phoneRaw}`} onClick={() => trackPhoneClick(`${testIdPrefix}-local-footer`)} data-testid={`${testIdPrefix}-local-footer-call`}>
              <Button className="w-full sm:w-auto bg-orange-700 hover:bg-orange-800 text-white font-bold uppercase tracking-wider text-sm h-12 px-7">
                <Phone className="h-4 w-4 mr-2" aria-hidden="true" /> Call {NAP.phone}
              </Button>
            </a>
            <Link to="/contact#book" data-testid={`${testIdPrefix}-local-footer-book`}>
              <Button variant="outline" className="w-full sm:w-auto border-white/30 text-white bg-white/5 hover:bg-white/15 hover:text-white font-bold uppercase tracking-wider text-sm h-12 px-7">
                <CalendarCheck className="h-4 w-4 mr-2" aria-hidden="true" /> Book Online at decatursolutionworks.com
              </Button>
            </Link>
          </div>

          <ul className="mt-7 grid sm:grid-cols-2 gap-2.5" data-testid={`${testIdPrefix}-local-footer-coverage`}>
            {COVERAGE_BULLETS.map((b) => (
              <li key={b} className="flex items-start gap-2 text-[14px] text-slate-200">
                <CheckCircle2 className="h-4 w-4 text-orange-400 mt-0.5 flex-shrink-0" aria-hidden="true" />
                <span>{b}</span>
              </li>
            ))}
          </ul>

          <div className="mt-7 pt-5 border-t border-white/10 flex flex-col sm:flex-row sm:items-center gap-4" data-testid={`${testIdPrefix}-local-footer-nap`}>
            <img
              src="/site-images/google-guaranteed-badge.png"
              alt="Google Guaranteed Service Provider - Decatur Solution Works"
              width={62}
              height={48}
              loading="lazy"
              decoding="async"
              className="h-12 w-auto object-contain flex-shrink-0"
            />
            <address className="not-italic text-[13px] text-slate-300 leading-relaxed flex items-start gap-2">
              <MapPin className="h-4 w-4 text-orange-400 mt-0.5 flex-shrink-0" aria-hidden="true" />
              <span>
                <strong className="text-white">{NAP.name}</strong> · {NAP.street}, {NAP.cityStateZip} ·{" "}
                <a href={`tel:${NAP.phoneRaw}`} className="underline underline-offset-2 hover:text-white">{NAP.phone}</a>
                <span className="block text-slate-400">Google Guaranteed · EPA 608 Certified · {variant === "commercial" ? "90-day parts & labor warranty on commercial repairs" : "1-year parts & labor warranty (one year on OEM parts)"}</span>
              </span>
            </address>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalConversionFooter;
